interface SidePanelLayoutProps {
  children: React.ReactNode;
}

export default function SidePanelLayout({ children }: SidePanelLayoutProps) {
  return <div className="flex flex-col h-full">{children}</div>;
}
